export default "/images/vendor/flag-icons/flags/4x3/sa.svg?406ec34cf4d0140f0f3ab956cd75ec06";